<template>
  <div class="follow-pop" @click.stop>
    <div class="head">
      <strong>关注送 {{ points }} 积分</strong>
      <button type="button" class="x" @click="$emit('close')">关闭</button>
    </div>

    <img v-if="qrVisible" :src="qrImage" alt="公众号二维码" @error="qrVisible = false" />
    <p v-else class="text">公众号二维码暂时打不开。</p>

    <template v-if="!authenticated || needLogin">
      <p class="text">扫码关注「{{ accountName }}」。登录邮箱账号后发送口令，即可领取 {{ points }} 积分。</p>
      <router-link v-if="!authenticated" class="go" to="/account?mode=login" @click="$emit('close')">去登录</router-link>
    </template>

    <template v-else-if="loading">
      <p class="text">正在获取口令…</p>
    </template>

    <template v-else-if="error">
      <p class="err">{{ error }}</p>
    </template>

    <template v-else-if="claimed">
      <p class="ok">已领取 {{ points }} 积分，微信已绑定当前账号。</p>
    </template>

    <template v-else>
      <p class="text">
        扫码关注「{{ accountName }}」，在对话里发送下面的口令。到账后这里会自动更新。
      </p>
      <p class="code">{{ code }}</p>
      <p class="hint">口令 24 小时内有效，同一账号只送一次。</p>
    </template>
    <PointsGuide inline />
  </div>
</template>

<script>
import PointsGuide from './PointsGuide.vue'
import { fetchFollowBonus } from '../api/platformService'

export default {
  name: 'FollowBonusPanel',
  components: { PointsGuide },
  props: {
    authenticated: { type: Boolean, default: false }
  },
  emits: ['close', 'credited'],
  data() {
    return {
      loading: false,
      error: '',
      claimed: false,
      needLogin: false,
      points: 20,
      code: '',
      accountName: '算力百科',
      qrImage: '/images/contact-qrcode.png',
      qrVisible: true,
      timer: null,
      notified: false
    }
  },
  watch: {
    authenticated: {
      immediate: true,
      handler() {
        this.load()
      }
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.authenticated && !this.claimed) this.load(true)
    }, 3000)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    async load(silent) {
      if (!silent) this.loading = this.authenticated
      this.error = ''
      try {
        const data = await fetchFollowBonus()
        const wasClaimed = this.claimed
        this.needLogin = Boolean(data.need_login)
        this.claimed = Boolean(data.claimed)
        this.points = data.points || 20
        this.code = data.code || ''
        this.accountName = data.account_name || '算力百科'
        this.qrImage = data.qr_image || '/images/contact-qrcode.png'
        if (this.claimed && !wasClaimed && !this.notified) {
          this.notified = true
          this.$emit('credited')
        }
      } catch (err) {
        if (!silent) this.error = err.response?.data?.error || '加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.follow-pop {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 340px;
  max-height: min(70vh, 640px);
  overflow: auto;
  padding: 14px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(29, 33, 41, 0.12);
  z-index: 40;
  text-align: left;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.head strong { font-size: 14px; }
.x {
  border: 0;
  background: transparent;
  color: #86909c;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}
.text, .hint { margin: 0 0 8px; color: #4e5969; font-size: 13px; line-height: 1.5; }
.hint { color: #86909c; font-size: 12px; margin: 8px 0 0; }
.ok { margin: 0; color: #188038; font-size: 13px; line-height: 1.5; }
.err { margin: 0; color: #d3382c; font-size: 13px; }
img {
  display: block;
  width: 140px;
  height: 140px;
  object-fit: contain;
  margin: 4px auto 8px;
  background: #fff;
  border-radius: 16px;
}
.code {
  margin: 0;
  text-align: center;
  font-size: 22px;
  letter-spacing: 2px;
  font-weight: 700;
  color: #1d2129;
}
.go {
  display: inline-block;
  margin-top: 4px;
  color: #165dff;
  font-size: 13px;
  text-decoration: none;
}
</style>
